import React from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import FieldBirthdate from '../../form/FieldBirthdate';
import Heading from '../../../common/heading/Heading';
import Button from '../../../common/buttons/onboarding/OnboardingButton';
import {
	NEXT,
	ONBOARDING_COMPLETE_BIRTHDATE_TITLE,
	ONBOARDING_COMPLETE_BIRTHDATE_SUBTITLE,
	ONBOARDING_BIRTHDATE_INVALID,
	ONBOARDING_BIRTHDATE_TOO_YOUNG,
} from '../../../../constants/Copy';
import OnboardingProgress from '../../common/onboardingProgress/OnboardingProgress.container';

const MIN_AGE = 16;

const RegisterBirthdate = ({ submitting, invalid, pristine, handleSubmit }) => {
	return (
		<form method="post" onSubmit={handleSubmit}>
			<OnboardingProgress activeStep={2} />
			<Heading>{ONBOARDING_COMPLETE_BIRTHDATE_TITLE}</Heading>
			<p className="onboarding__text">{ONBOARDING_COMPLETE_BIRTHDATE_SUBTITLE}</p>
			<Field name="birthdate" testId="birthdate" component={FieldBirthdate} />
			<Button
				testId="birthdate-button"
				loading={submitting}
				disabled={invalid || pristine}
				type="submit"
			>
				{NEXT}
			</Button>
		</form>
	);
};

PropTypes.RegisterBirthdate = {
	handleSubmit: PropTypes.func.isRequired,
};

/**
 * Expects date to be in ISO format: 1955-01-01.
 */
const doesDateExist = (birthdate) => {
	const [birthYear, birthMonth, birthDay] = birthdate.split('-');
	const date = new Date(
		parseInt(birthYear, 10),
		parseInt(birthMonth, 10) - 1,
		parseInt(birthDay, 10)
	);
	return date && date.getMonth() === parseInt(birthMonth) - 1;
};

/**
 * Expects date to be in ISO format: 1955-01-01.
 */
const minAgeCheck = (birthdate) => {
	const ageDiffMs = Date.now() - new Date(birthdate).getTime();
	const ageDate = new Date(ageDiffMs); // miliseconds from epoch
	return Math.abs(ageDate.getUTCFullYear() - 1970) >= MIN_AGE;
};

const validate = ({ birthdate }) => {
	if (!birthdate || !doesDateExist(birthdate)) {
		return { birthdate: ONBOARDING_BIRTHDATE_INVALID };
	} else if (!minAgeCheck(birthdate)) {
		return { birthdate: ONBOARDING_BIRTHDATE_TOO_YOUNG };
	}
	return null;
};

export default reduxForm({
	form: 'register',
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
	validate,
})(RegisterBirthdate);
